import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconChat = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path d="M9.65445 7.1H19.5817C20.862 7.1 21.8999 8.13789 21.8999 9.41818V20.7636L21.894 20.8704C21.8126 21.6 20.9047 21.9412 20.3635 21.4L17.7919 18.827L9.65445 18.8273C8.37415 18.8273 7.33627 17.7894 7.33627 16.5091V9.41818C7.33627 8.13789 8.37415 7.1 9.65445 7.1ZM19.5817 8.9H9.65445C9.36826 8.9 9.13627 9.132 9.13627 9.41818V16.5091C9.13627 16.7953 9.36826 17.0273 9.65445 17.0273H18.1635L18.2818 17.0351C18.4769 17.0609 18.6593 17.1502 18.7999 17.2909L20.1009 18.591L20.0999 9.41818C20.0999 9.132 19.8679 8.9 19.5817 8.9ZM5.0999 3C3.94011 3 2.9999 4.00736 2.9999 5.25V12.75C2.9999 13.9926 3.94011 15 5.0999 15H5.7999V13.5H5.0999C4.77355 13.5 4.49936 13.2607 4.42183 12.937L4.40461 12.8375L4.3999 12.75V5.25C4.3999 4.83579 4.7133 4.5 5.0999 4.5H14.8999C15.2865 4.5 15.5999 4.83579 15.5999 5.25L15.6009 6H16.9999V5.25C16.9999 4.06139 16.1397 3.08804 15.0499 3.00565L14.8999 3H5.0999Z" />
      </svg>
    );
  }
);
